import { render } from "./EverydayLife-3.vue?vue&type=template&id=06a4b40c"
import script from "./EverydayLife-3.vue?vue&type=script&lang=js"
export * from "./EverydayLife-3.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__